function animateValueUpdate(element, start, end, duration, soundFilePath = null) {
    // Ensure values are integers
    start = parseInt(start);
    end = parseInt(end);

    // Timestamp when the animation starts
    let startTime = null;

    // Optional: Play sound if soundFilePath is provided
    if (soundFilePath) {
        const audio = new Audio(soundFilePath);
        audio.play().catch(error => console.error("Error playing sound:", error));
    }

    // Easing function: accelerate at the beginning and slow down at the end
    function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }

    // The update function, called every frame
    function update(currentTime) {
        // Set the start time on the first frame
        if (startTime === null) {
            startTime = currentTime;
        }

        // Calculate the elapsed time since the start of the animation
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);

        // Calculate the current value with the easing function
        const currentValue = Math.round(start + (end - start) * easeInOutQuad(progress));

        // Update the element's text content with the current value
        element.textContent = currentValue;

        // If the animation hasn't finished, request the next frame
        if (timeElapsed < duration) {
            requestAnimationFrame(update);
        }
    }

    // Start the animation
    requestAnimationFrame(update);
}
